// extracted by mini-css-extract-plugin
export default {"content":"Content-module__content__HjO37","list":"Content-module__list__WdHW1","title":"Content-module__title__pM03W"};